import sessionService from '@/services/sessionService';
import getEnv from '@shared/utils/env';
import router from '@/router';
import { navigate } from '@/utils/navigation';
import { carriedReturnTo, safeReturnTo } from '@/utils/returnTo';

/**
 * Sends a verified session on to its return address, or the application, and an unverified one
 * to verification with the same return address. An unverified session already on verification
 * stays, so that a verification link keeps its flow and code. Resolves to whether the browser is
 * leaving the portal; rejects when nobody is signed in.
 */
export async function redirectIfConnected(): Promise<boolean> {
  await router.isReady();
  const response = await sessionService.current();
  const attributes = response.data?.data?.attributes;
  const query = router.currentRoute.value.query;
  if (attributes?.verified) {
    navigate(safeReturnTo(query.returnTo) ?? getEnv('VUE_APP_APP_URL') ?? '/');
    return true;
  }
  if (router.currentRoute.value.name !== 'verify') {
    await router.push({
      name: 'verify',
      query: { email: attributes?.email, ...carriedReturnTo(query) },
    });
  }
  return false;
}
